export const PROFILE_ROUTE = process.env.NODE_ENV === 'development' ?
  '/iframe.html?args=&globals=&id=profilecontainer--default&' :
  '/profile?'
